import { createSlice } from '@reduxjs/toolkit';
import { initStateGetStats, reducerGetStats } from '../actions/dashborad/getStats';
import { initStateGetVacancyList, reducerGetVacancyList } from '../actions/dashborad/getVacancyList';
import { initStateGetVacancySingle, reducerGetVacancySingle } from '../actions/dashborad/getVacancySingle';
import { initStateDeleteVacancyList, reducerDeleteVacancyList } from '../actions/dashborad/deleteVacancyList';
import { initStateSkipVerification, reducerSkipVerification } from '../actions/dashborad/skipVerification';
import { initStateCreateVacancy, reducerCreateVacancy } from '../actions/dashborad/createVacancy';
import { initStateUpdateManagerVacancy, reducerUpdateManagerVacancy } from '../actions/dashborad/updateManagerVacancy';
import { initStateUpdateModerationVacancy, reducerUpdateModerationVacancy } from '../actions/dashborad/updateModerationVacancy';
import { initStateGetModerationVacancy, reducerGetModerationVacancy } from '../actions/dashborad/getModerationVacancy';
import { initStateSentModerationVacancy, reducerSentModerationVacancy } from '../actions/dashborad/sentModerationVacancy';
import { initStateRemoveModerationVacancy, reducerRemoveModerationVacancy } from '../actions/dashborad/removeModerationVacancy';
import { initStateRemoveSentModerationVacancy, reducerRemoveSentModerationVacancy } from '../actions/dashborad/removeSentModerationVacancy';
import { initStateRemoveVacancy, reducerRemoveVacancy } from '../actions/dashborad/removeVacancy';
import { initStateDisableVacancyList, reducerDisableVacancyList } from '../actions/dashborad/disableVacancyList';
import { initStateAcceptModeration, reducerAcceptModeration } from '../actions/dashborad/acceptModeration';
import { initStateUpdateVacancy, reducerUpdateVacancy } from '../actions/dashborad/updateVacancy';
import { initStateSendToModeration, reducerSendToModeration } from '../actions/dashborad/sendToModeration';

export const initialState = {
  ...initStateGetStats,
  ...initStateGetVacancyList,
  ...initStateGetVacancySingle,
  ...initStateDeleteVacancyList,
  ...initStateSkipVerification,
  ...initStateCreateVacancy,
  ...initStateUpdateManagerVacancy,
  ...initStateUpdateModerationVacancy,
  ...initStateGetModerationVacancy,
  ...initStateSentModerationVacancy,
  ...initStateRemoveModerationVacancy,
  ...initStateRemoveSentModerationVacancy,
  ...initStateRemoveVacancy,
  ...initStateDisableVacancyList,
  ...initStateAcceptModeration,
  ...initStateUpdateVacancy,
  ...initStateSendToModeration,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    resetDeleteVacancyList(state, action) {
      state.deleteVacancyList = initStateDeleteVacancyList.deleteVacancyList;
    },
    resetGetVacancyList(state, action) {
      state.getVacancyList = initStateGetVacancyList.getVacancyList;
    },
    resetGetVacancySingle(state, action) {
      state.getVacancySingle = initStateGetVacancySingle.getVacancySingle;
    },
    resetGetStats(state, action) {
      state.getStats = initStateGetStats.getStats;
    },
    resetCreateVacancy(state, action) {
      state.createVacancy = initStateCreateVacancy.createVacancy;
    },
    resetRemoveVacancy(state, action) {
      state.removeVacancy = initStateRemoveVacancy.removeVacancy;
    },
    resetSkipVerification(state, action) {
      state.skipVerification = initStateSkipVerification.skipVerification;
    },
    resetUpdateManagerVacancy(state, action) {
      state.updateManagerVacancy = initStateUpdateManagerVacancy.updateManagerVacancy;
    },
    resetUpdateModerationVacancy(state, action) {
      state.updateModerationVacancy = initStateUpdateModerationVacancy.updateModerationVacancy;
    },
    resetRemoveModerationVacancy(state, action) {
      state.removeModerationVacancy = initStateRemoveModerationVacancy.removeModerationVacancy;
    },
    resetGetModerationVacancy(state, action) {
      state.getModerationVacancy = initStateGetModerationVacancy.getModerationVacancy;
    },
    resetSentModerationVacancy(state, action) {
      state.sentModerationVacancy = initStateSentModerationVacancy.sentModerationVacancy;
    },
    resetRemoveSentModerationVacancy(state, action) {
      state.removeSentModerationVacancy = initStateRemoveSentModerationVacancy.removeSentModerationVacancy;
    },
    resetDisableVacancyList(state, action) {
      state.disableVacancyList = initStateDisableVacancyList.disableVacancyList;
    },
    resetAcceptModeration(state, action) {
      state.acceptModeration = initStateAcceptModeration.acceptModeration;
    },
    resetUpdateVacancy(state, action) {
      state.updateVacancy = initStateUpdateVacancy.updateVacancy;
    },
    resetSendToModeration(state, action) {
      state.sendToModeration = initStateSendToModeration.sendToModeration;
    },
  },
  extraReducers: {
    ...reducerGetStats,
    ...reducerGetVacancyList,
    ...reducerGetVacancySingle,
    ...reducerDeleteVacancyList,
    ...reducerSkipVerification,
    ...reducerCreateVacancy,
    ...reducerUpdateManagerVacancy,
    ...reducerUpdateModerationVacancy,
    ...reducerGetModerationVacancy,
    ...reducerSentModerationVacancy,
    ...reducerRemoveModerationVacancy,
    ...reducerRemoveSentModerationVacancy,
    ...reducerRemoveVacancy,
    ...reducerDisableVacancyList,
    ...reducerAcceptModeration,
    ...reducerUpdateVacancy,
    ...reducerSendToModeration,
  },
});
export const {
  resetUpdateVacancy,
  resetAcceptModeration,
  resetDisableVacancyList,
  resetGetVacancySingle,
  resetRemoveVacancy,
  resetRemoveSentModerationVacancy,
  resetRemoveModerationVacancy,
  resetSentModerationVacancy,
  resetGetModerationVacancy,
  resetUpdateModerationVacancy,
  resetUpdateManagerVacancy,
  resetCreateVacancy,
  resetSkipVerification,
  resetGetVacancyList,
  resetGetStats,
  resetDeleteVacancyList,
  resetSendToModeration,
} = dashboardSlice.actions;
export const dashboardReducer = dashboardSlice.reducer;
